/* eslint-disable no-unsafe-optional-chaining */

'use client';

import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: scroll;
`;

const HoverPatern = css`
  background: repeating-linear-gradient(45deg, #fff, #fff 10px, var(--grey) 10px, var(--grey) 15px);
`;

const ListItem = styled.li`
  cursor: pointer;
  padding: 10px;
  &:nth-child(odd) {
    background: #fff;
  }
  &:nth-child(
      ${(props) => props.$selectedMarker?.type === 'mouseenter' && props?.$selectedMarker?.index + 1}
    ) {
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);
    ${HoverPatern}
  }
  &:hover {
    ${HoverPatern}
  }
`;

const Name = styled.h4`
  margin: 0;
`;

const Address = styled.small`
  font-family: ${(props) => props.theme.fonts.sansSerif};
  display: block;
  line-height: 0.85rem;
  color: var(--red);
  font-weight: 500;
`;

const RecordStoreList = ({ results, selectedMarker = null, selectedListItem }) => {
  const listRef = useRef([]);
  useEffect(() => {
    if (selectedMarker) {
      listRef.current[selectedMarker.index].scrollIntoView({
        behavior: 'smooth',
        alignToTop: true
      });
    }
  }, [selectedMarker]);

  if (results) {
    return (
      <List>
        {results.map((el, i) => (
          <ListItem
            onClick={() => selectedListItem(i)}
            // eslint-disable-next-line no-return-assign
            ref={(element) => (listRef.current[i] = element)}
            key={el.reference}
            $selectedMarker={selectedMarker}
          >
            <Name>{el.name}</Name>
            <Address>{el.vicinity}</Address>
          </ListItem>
        ))}
      </List>
    );
  }
  return null;
};

RecordStoreList.propTypes = {
  results: PropTypes.arrayOf(PropTypes.shape({})),
  selectedMarker: PropTypes.shape({ type: PropTypes.string, index: PropTypes.number }),
  selectedListItem: PropTypes.func.isRequired
};

export default RecordStoreList;
